import React from "react";
import styles from "../RolesPermissonForm.module.scss";
import InputField from "../../../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { SettingsPermissions } from "../constants";
import { useFormContext } from "react-hook-form";

const SettingsSectionOptions = () => {
  const { watch } = useFormContext();

  return (
    <div>
      {SettingsPermissions.map((item) => (
        <div className={styles.optionWrapper}>
          <span className={styles.optionTitle}>{item.label}</span>
          <div className={styles.optionToggle}>
            <InputField
              name={item.name}
              type={InputfieldTypes.SWITCH}
              defaultSwitch={watch(item.name)}
              value={watch(item.name)}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SettingsSectionOptions;
